import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClaimLeadBarSmartComponent } from './claim-lead-bar-smart/claim-lead-bar-smart.component';
import { ClaimLeadBarComponent } from './claim-lead-bar/claim-lead-bar.component';
import { MatButtonModule } from '@angular/material/button';
import { UnattemptedDropdownModule } from 'app/unattempted-dropdown/unattempted-dropdown.module';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AlertModule } from 'app/components/alert/alert.module';


@NgModule({
  declarations: [
    ClaimLeadBarSmartComponent,
    ClaimLeadBarComponent
  ],
  imports: [
    AlertModule,
    CommonModule,
    MatButtonModule,
    UnattemptedDropdownModule,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  exports: [
    ClaimLeadBarSmartComponent
  ]
})
export class ClaimLeadBarModule { }
